import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["form", "results"]

    #timer = null
    #selectedIndex = -1

    connect() {
        this.element.addEventListener("turbo:frame-load", this.#onFrameLoad)
    }

    disconnect() {
        if (this.#timer) clearTimeout(this.#timer)
        this.element.removeEventListener("turbo:frame-load", this.#onFrameLoad)
    }

    submit() {
        if (this.#timer) clearTimeout(this.#timer)
        this.#timer = setTimeout(() => {
            this.#selectedIndex = -1
            this.formTarget.requestSubmit()
        }, 300)
    }

    onKeydown(event) {
        const results = this.#getResults()

        if (event.key === "ArrowDown") {
            event.preventDefault()
            if (results.length === 0) return
            this.#select(Math.min(this.#selectedIndex + 1, results.length - 1), results)
        } else if (event.key === "ArrowUp") {
            event.preventDefault()
            this.#select(Math.max(this.#selectedIndex - 1, -1), results)
        } else if (event.key === "Enter" && this.#selectedIndex >= 0 && this.#selectedIndex < results.length) {
            event.preventDefault()
            results[this.#selectedIndex].click()
        }
    }

    // --- Private ---

    #onFrameLoad = () => {
        this.#selectedIndex = -1
    }

    #getResults() {
        if (!this.hasResultsTarget) return []
        return [...this.resultsTarget.querySelectorAll("a[href]")]
    }

    #select(index, results) {
        if (this.#selectedIndex >= 0 && this.#selectedIndex < results.length) {
            results[this.#selectedIndex].classList.remove("search-result-selected")
        }

        this.#selectedIndex = index

        if (index >= 0 && index < results.length) {
            results[index].classList.add("search-result-selected")
            results[index].scrollIntoView({ behavior: "smooth", block: "nearest" })
        }
    }
}
